import { render, staticRenderFns } from "./CommodityDesign.vue?vue&type=template&id=6e1eb3d8&scoped=true&"
import script from "./CommodityDesign.vue?vue&type=script&lang=js&"
export * from "./CommodityDesign.vue?vue&type=script&lang=js&"
import style0 from "./CommodityDesign.vue?vue&type=style&index=0&id=6e1eb3d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1eb3d8",
  null
  
)

export default component.exports